var map = {
	"./btn.json": "e6f1",
	"./company.json": "48b3",
	"./contact.json": "00ef",
	"./error.json": "c1a3",
	"./faq.json": "35c6",
	"./footer.json": "07f9",
	"./header.json": "cfeb",
	"./meta.json": "b47d",
	"./msg.json": "a6a9",
	"./news.json": "0742",
	"./policy.json": "433d",
	"./streamer.json": "e13f",
	"./terms.json": "b0bc",
	"./top.json": "2b99",
	"./tradelaw.json": "911d",
	"./usage.json": "f553"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bbc";